////////////*Feature:Drag and Drop///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
var dndResetObject = {};
/**
 * @param revertTime
 * @param dndAnswers
 */
function resetDnD(revertTime, dndAnswers) {
	if (globalVar.curSlide === 'I1-B') {
		$('#forest').removeClass('blue-sky green-sky blue-plants green-plants');
	}
	globalVar.$curSlide.find('.draggable').each(function () {
		var OGPos = $(this).data('OGPos');
		$(this).animate(
			{
				top: OGPos.top,
				left: OGPos.left
			},
			revertTime
		);
		$(this).data('dropId', '');
		$(this).data('curPos', {
			top: OGPos.top,
			left: OGPos.left
		});
		$(this).data('prevPos', {
			top: OGPos.top,
			left: OGPos.left
		});
	});
	globalVar.$curSlide.find('.droppable').each(function () {
		$(this).data('dragElements', []);
		$(this).data('dropCounter', slides[globalVar.curSlide].dnd.dropCounter[this.id]);
	});
	//reset dndAnswersect
	for (key in dndAnswers) {
		dndAnswers[key] = [];
	}

	if (slides[globalVar.curSlide].dnd.type == 'dnd_2') {
		globalVar.$curSlide.find('.draggable').fadeIn();
		globalVar.$curSlide.find('.draggable').removeClass('shrink');
	}

	globalVar.dndAnswers = dndAnswers;
	return dndAnswers;
}

/**
 *
 */
function dndFunctions() {
	var curDrag;
	var curDrop;
	var $dragElements = globalVar.$curSlide.find('.draggable');
	var $dropElements = globalVar.$curSlide.find('.droppable');
	var revertTime;
	var snapping;
	var dndAnswers = generateAnswerTemplate();

	// assign custom or default values to revert and snapping
	if (slides[globalVar.curSlide].dnd.revertTime) {
		revertTime = slides[globalVar.curSlide].dnd.revertTime;
	} else {
		revertTime = 500;
	}
	if (slides[globalVar.curSlide].dnd.snapping) {
		snapping = slides[globalVar.curSlide].dnd.snapping;
	} else {
		snapping = true;
	}

	///////////////// First entrance setup/////////////////////////////////
	if (slides[globalVar.curSlide].visited == false) {
		// draggable setup: set position data, attaches dnd event functions, add keyboard access
		$dragElements.each(function () {
			var events = dndActions(this.id);
			var leftInit = ((parseInt($(this).css('left')) / $(this).parent().width()) * 100).toString() + '%';
			var topInit = ((parseInt($(this).css('top')) / $(this).parent().height()) * 100).toString() + '%';
			$(this).data({
				OGPos: {
					top: topInit,
					left: leftInit
				},
				curPos: {
					top: topInit,
					left: leftInit
				},
				prevPos: {
					top: topInit,
					left: leftInit
				},
				dropID: '',
				events: events,
				revertTime: revertTime,
				snapping: snapping
			});

			// makes dnd keyboard accessible
			$(this).attr('tabindex', '0');
			keyBoardAccess(this);
		});

		// droppable setup: drag array, drop counter, keyboard access
		$dropElements.each(function () {
			$(this).data({
				dragElements: [],
				dropCounter: slides[globalVar.curSlide].dnd.dropCounter[this.id]
			});

			// necessary to make dnd keyboard accessible
			$(this).attr('tabindex', '-1');
		});

		dndResetObject[globalVar.curSlide] = {
			time: revertTime,
			answers: dndAnswers
		};
		// Subsequent Visits/////////////////////////////////////////
	} else {
		$dragElements.each(function () {
			$(this).draggable('disable');
		});
		$dropElements.each(function () {
			$(this).droppable('disable');
		});
		resetDnD(revertTime, dndAnswers);
	}
	// end setup

	// draggable options: add any additional needed keys from jQuery draggable API here
	$dragElements.draggable({
		start: function (event, ui) {
			curDrag = ui.helper[0];
			$(curDrag).data('events').onDragStart();
		},
		drag: function (event, ui) {
			dragging(curDrag);
		},
		revert: 'invalid',
		stack: '.draggable',
		revertDuration: revertTime,
		stop: function (event, ui) {
			dragStop(curDrag);
		}
	});

	// droppable options: add any additional needed keys from jQuery droppable API here
	$dropElements.droppable({
		accept: '.draggable',
		over: function (event, ui) {
			curDrop = event.target;
			if ($(curDrag).data('events').onDragOver[curDrop.id]) {
				$(curDrag).data('events').onDragOver[curDrop.id]();
			}
		},
		drop: function (event, ui) {
			dropped(curDrop, curDrag);
		}
	});

	// activate both
	$dragElements.each(function () {
		$(this).draggable('enable');
	});

	$dropElements.each(function () {
		$(this).droppable('enable');
	});
} //end dndFunctions

// Dnd Event Functions///////////////////////////////

// runs while dragging element;
/**
 * @param dragTarget
 */
function dragging(dragTarget) {
	$(dragTarget).data('events').onDrag();
}

// runs when drag element is released outside of valid drop area;
/**
 * @param dragTarget
 */
function dragStop(dragTarget) {
	$(dragTarget).data('events').onDragEnd();
}

//Important Function! Runs on drop into valid drop area///
/**
 * @param dropTarget
 * @param dragTarget
 */
function dropped(dropTarget, dragTarget) {
	var pos = {
		top: 0,
		left: 0
	};
	var snapping = $(dragTarget).data('snapping');
	var spaceAvailable = $(dropTarget).data('dragElements').length < $(dropTarget).data('dropCounter');

	//get positioning
	if (snapping) {
		pos.top = ((parseInt($(dropTarget).css('top')) / $(dropTarget).parent().height()) * 100).toString() + '%';
		pos.left = ((parseInt($(dropTarget).css('left')) / $(dropTarget).parent().width()) * 100).toString() + '%';
	} else {
		pos.top = ((parseInt($(dragTarget).css('top')) / $('.reveal').height()) * 100).toString() + '%';
		pos.left = ((parseInt($(dragTarget).css('left')) / $('.reveal').width()) * 100).toString() + '%';
	}

	// run custom drop function
	if ($(dragTarget).data('events').onDrop[dropTarget.id]) {
		$(dragTarget).data('events').onDrop[dropTarget.id]();
	}

	// handle drop for each type
	if (slides[globalVar.curSlide].dnd.type == 'dnd_2') {
		if (spaceAvailable) {
			dnd2Drop(dragTarget, dropTarget);
		} else {
			revert(dragTarget);
		}
	} else if (slides[globalVar.curSlide].dnd.type == 'dnd_1') {
		if (spaceAvailable) {
			dnd1Drop(dragTarget, dropTarget, pos);
		} else {
			swap(dragTarget, dropTarget, pos);
		}
	}

	for (key in slides[globalVar.curSlide].dnd.quiz) {
		globalVar.dndAnswers[key] = $('#' + key).data('dragElements');
	}
} //end dropped

//////// Drops and Swap /////////////

/**
 * @param drag
 * @param drop
 */
function dnd2Drop(drag, drop) {
	$(drop).data('dragElements').push(drag.id);
	$(drag).addClass('shrink');
	$(drag).data('dropped', true);
}

/**
 * @param drag
 * @param drop
 * @param pos
 */
function dnd1Drop(drag, drop, pos) {
	var dropId = $(drag).data('dropId');
	if (dropId) {
		var newArr = $('#' + dropId)
			.data('dragElements')
			.filter(function (dragId) {
				dragId !== drag.id;
			});
		$('#' + dropId).data('dragElements', newArr);
	}
	updatePos(drag, pos);
	$(drag).data('dropId', drop.id);
	$(drop).data('dragElements').push(drag.id);
	move(drag);
}

/**
 * @param drag
 * @param drop
 * @param pos
 */
function swap(drag, drop, pos) {
	var dropId = $(drag).data('dropId');
	var swapDragId = $(drop).data('dragElements').pop();
	var swapDrag = $('#' + swapDragId);
	var swapDragPos;
	var swapArr = [];

	if (dropId) {
		var newArr = $('#' + dropId)
			.data('dragElements')
			.filter(function (dragId) {
				dragId !== drag.id;
			});
		newArr.push(swapDragId);
		$('#' + dropId).data('dragElements', newArr);
		swapDragPos = $(drag).data('curPos');
	} else {
		swapDragPos = $(swapDrag).data('OGPos');
		swapDrag.removeData('dropId');
	}
	swapArr = $('#' + drop.id)
		.data('dragElements')
		.filter(function (dragId) {
			dragId !== swapDragId;
		});
	swapArr.push(drag.id);
	$('#' + drop.id).data('dragElements', swapArr);

	$(drag).data('dropId', drop.id);
	$(swapDrag).data('dropId', dropId);

	updatePos(swapDrag, swapDragPos);
	updatePos(drag, pos);

	move(drag);
	move(swapDrag);
}

/////////////////// DnD Helper Functions///////////////////////////////////////////////////
/**
 * @param dragItem
 */
function revert(dragItem) {
	var revertTime = $(dragItem).data('revertTime');
	$(dragItem).animate(
		{
			top: $(dragItem).data('prevPos').top,
			left: $(dragItem).data('prevPos').left
		},
		revertTime
	);
}

/**
 * @param dragItem
 */
function move(dragItem) {
	var revertTime = 300;
	$(dragItem).animate(
		{
			top: $(dragItem).data('curPos').top,
			left: $(dragItem).data('curPos').left
		},
		revertTime
	);
}

/**
 * @param dragItem
 * @param newPos
 */
function updatePos(dragItem, newPos) {
	$(dragItem).data('prevPos', $(dragItem).data('curPos'));
	$(dragItem).data('curPos', newPos);
}

// Grabs custom event actions or assigns default values to all action keys. Makes action key entirely optional
/**
 * @param dragItemID
 */
function dndActions(dragItemID) {
	var actions = {
		onDragStart: function () {},
		onDrag: function () {},
		onDragOver: {},
		onDragEnd: function () {},
		onDrop: {}
	};
	if (slides[globalVar.curSlide].dnd.actions) {
		if (!slides[globalVar.curSlide].dnd.actions[dragItemID]) {
			slides[globalVar.curSlide].dnd.actions[dragItemID] = {};
		}
		for (var key in actions) {
			if (slides[globalVar.curSlide].dnd.actions[dragItemID][key]) {
				actions[key] = slides[globalVar.curSlide].dnd.actions[dragItemID][key];
			}
		}
	} else {
		slides[globalVar.curSlide].dnd.actions = {};
	}
	slides[globalVar.curSlide].dnd.actions[dragItemID] = actions;
	return actions;
}

/**
 *
 */
function generateAnswerTemplate() {
	var i = 0;
	var str = '';
	var dndAnswers;
	//write a blank object/answers into the globalVar
	globalVar.dndAnswers = {};
	for (key in slides[globalVar.curSlide].dnd.quiz) {
		i++;

		var stra = '"' + key + '":' + '[]';
		if (Object.keys(slides[globalVar.curSlide].dnd.quiz).length >= 2) {
			if (i != Object.keys(slides[globalVar.curSlide].dnd.quiz).length) {
				stra = stra + ',';
			}
		}
		str = str + stra;
	}
	str = '{' + str + '}';
	dndAnswers = JSON.parse(str);
	globalVar.dndAnswers = dndAnswers;
	return dndAnswers;
}

/**
 * @param dragElement
 */
function keyBoardAccess(dragElement) {
	var accessibility = function (event) {
		var drops = globalVar.$curSlide.find('.droppable');
		var dropIdx = 0;
		var $drag = $(this);
		if (event.which === 32) {
			//spacebar selects drag element

			$(drops[dropIdx]).focus(); //focuses on first drop area
			$drag.off('keydown.access'); //removes spacebar selector
			dragging($drag[0]); //takes care of drag events

			$('body').on('keydown.drag', function (event) {
				switch (event.keyCode) {
					case 9: //removes ability to tab while drag element is selected
						event.preventDefault();
						break;
					case 27: // allows user to press escape key to return to normal and places focus on drag element
						$drag.animate(
							{
								top: $drag.data('originalTop'),
								left: $drag.data('originalLeft')
							},
							revertTime
						);
						$drag.focus();

						$drag.on('keydown.access', accessibility);
						$('body').off('keydown.drag');
						break;
					case 38: //up arrow cycles through drop targets
						if (dropIdx < drops.length - 1) {
							dropIdx += 1;
						} else {
							dropIdx = 0;
						}
						$(drops[dropIdx]).focus();
						break;
					case 40: //down arrow cycles through drop targets
						if (dropIdx > 0) {
							dropIdx -= 1;
						} else {
							dropIdx = drops.length - 1;
						}
						$(drops[dropIdx]).focus();
						break;
					case 13: //enter key drops selected drag element into currently focused drop area
						dropped(drops[dropIdx], $drag[0]);
						if (slides[globalVar.curSlide].dnd.type === 'dnd_2') {
							$drag.blur();
						} else {
							$drag.focus();
						}
						$drag.on('keydown.access', accessibility);
						$('body').off('keydown.drag');
						break;
					default:
						return true;
				}
			});
		}
	};
	$(dragElement).on('keydown.access', accessibility);
}
